export default {
  zh: {
    find: 'Find',
    inviteHistory: 'Invite History',
    inviteID: 'Inviter ID',
    invitees: 'Invitees',
    timeInvited: 'Time Invited',
    id: 'ID',
    enterID: 'Enter the account ID',
    notExist: 'The user does not exist',
    successful: 'The operation was successful',
    haveHost: 'The user joined another guild',
    invite: 'Invite'
  },
  en: {
    find: 'Find',
    inviteHistory: 'Invite History',
    inviteID: 'Inviter ID',
    invitees: 'Invitees',
    timeInvited: 'Time Invited',
    id: 'ID',
    enterID: 'Enter the account ID',
    notExist: 'The user does not exist',
    successful: 'The operation was successful',
    haveHost: 'The user joined another guild',
    invite: 'Invite'
  },
  ar: {
    // 阿拉伯
    find: 'بحث',
    inviteHistory: 'دعوة السجل',
    inviteID: 'ايدي المدعو',
    invitees: 'المدعوون ',
    timeInvited: 'وقت الدعوة ',
    id: 'معرف',
    enterID: 'ادخل ايدي الحساب',
    notExist: 'المستخدم غير موجود',
    successful: 'العملية كانت ناجحه',
    haveHost: 'انضم المستخدم إلى نقابة أخرى',
    invite: 'دعوة'
  },
  tr: {
    //土耳其
    find: 'Bul',
    inviteHistory: 'Davet Geçmişi',
    inviteID: 'Davet Eden Kimliği',
    invitees: 'Davetliler',
    timeInvited: 'Davet Edilen Zaman',
    id: 'KİMLİĞİ',
    enterID: 'Hesap ID Girin',
    notExist: 'Kullanıcı mevcut değil',
    successful: 'İşlem Başarılı Oldu',
    haveHost: 'Kullanıcı başka bir loncaya katıldı',
    invite: 'Davet Et'
  },
  pt: {
    find: 'Encontrar',
    inviteHistory: 'Histórico de Convites',
    inviteID: 'ID do Convidador',
    invitees: 'Convidados',
    timeInvited: 'Hora do Convite',
    id: 'ID',
    enterID: 'Digite o ID da conta',
    notExist: 'O usuário não existe',
    successful: 'A operação foi bem-sucedida',
    haveHost: 'O usuário entrou em outra guilda',
    invite: 'Convidar'
  },
  id: {
    find: 'Temukan',
    inviteHistory: 'Riwayat Undangan',
    inviteID: 'ID Pengundang',
    invitees: 'Undangan',
    timeInvited: 'Waktu Undangan',
    id: 'ID',
    enterID: 'Masukkan ID akun',
    notExist: 'Pengguna tidak ada',
    successful: 'Operasi berhasil',
    haveHost: 'Pengguna telah bergabung dengan guild lain',
    invite: 'Undang'
  },
  uz: {
    find: 'Topish',
    inviteHistory: 'Taklif Tarixi',
    inviteID: 'Taklif qiluvchi ID',
    invitees: 'Taklif qilinganlar',
    timeInvited: 'Taklif qilingan vaqt',
    id: 'ID',
    enterID: "Hisob ID'sini kiriting",
    notExist: 'Foydalanuvchi mavjud emas',
    successful: 'Amal muvaffaqiyatli bajarildi',
    haveHost: "Foydalanuvchi boshqa guildga qo'shildi",
    invite: 'Taklif qilish'
  },
  ru: {
    find: 'Найти',
    inviteHistory: 'История приглашений',
    inviteID: 'ID пригласителя',
    invitees: 'Приглашённые',
    timeInvited: 'Время приглашения',
    id: 'ID',
    enterID: 'Введите ID аккаунта',
    notExist: 'Пользователь не существует',
    successful: 'Операция выполнена успешно',
    haveHost: 'Пользователь присоединился к другой гильдии',
    invite: 'Пригласить'
  },
  fa: {
    find: 'یافتن',
    inviteHistory: 'تاریخ دعوت',
    inviteID: 'شناسه دعوت‌کننده',
    invitees: 'دعوت‌شدگان',
    timeInvited: 'زمان دعوت',
    id: 'شناسه',
    enterID: 'شناسه حساب را وارد کنید',
    notExist: 'کاربر وجود ندارد',
    successful: 'عملیات با موفقیت انجام شد',
    haveHost: 'کاربر به گیلد دیگری پیوسته است',
    invite: 'دعوت'
  },
  ur: {
    find: 'تلاش کریں',
    inviteHistory: 'دعوتی تاریخ',
    inviteID: 'دعوت دہندہ کی آئی ڈی',
    invitees: 'مدعو افراد',
    timeInvited: 'دعوت کا وقت',
    id: 'آئی ڈی',
    enterID: 'اکاؤنٹ آئی ڈی درج کریں',
    notExist: 'صارف موجود نہیں ہے',
    successful: 'عمل کامیاب رہا',
    haveHost: 'صارف پہلے ہی کسی اور گیلڈ میں شامل ہے',
    invite: 'دعوت دیں'
  }
}



// WEBPACK FOOTER //
// src/pages/app/invite-new-host/lang.js